export default "__VITE_ASSET__DvatExXG__"